import vueDragResizable from "components/publicComponent/vueDragRiseable/vue-drag-resizable.vue"
import layoutComponent from "materials/layout/render/index.vue"
import cxEarth from "materials/bigScreen/earth/render/index.vue" //cxEarth
import cxMap from "materials/bigScreen/map/render/index.vue" //cxMap
import { componentsMixins } from "core/materialLoader"
export default {
  components: {
    layoutComponent,
    ...componentsMixins,
    // cxMore,
    // cacheComponent,
    cxMap: cxEarth,
    cxRealMap: cxMap,
    vueDragResizable
  }
}
